const resource = {
    resource_identifier_in_use: "L'identificatore API {{indicator}} è già in uso",
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
